import SignupPageExtension from "../../../@libs/Extensions/SignupPageExtension";

class SignupWithEmailStore extends SignupPageExtension {
	constructor(rootStore) {
		super(rootStore);
	}

	updateZipcode(...args) {
		return super.updateZipcode(...args);
	}
}

export default SignupWithEmailStore;
